// @ts-ignore
import CourseRooms from "./CourseRooms.tsx";
// @ts-ignore
import BoxSettings from "./BoxSettings.tsx";
// @ts-ignore
import ContractSettings from "./Contracts.tsx";
// @ts-ignore
import {TabMenu} from "../TabMenu.tsx";
// @ts-ignore
import EmailStrings from "./EmailStrings.tsx";

export default function Settings(){

  return (<div style={{position: "relative", width: "100%", height: "100%"}}>
    <TabMenu tabs={["Box-Daten", "Kurse & Räume", "Verträge", "Email Texte"]}>
      <BoxSettings/>
      <CourseRooms/>
      <ContractSettings/>
      <EmailStrings/>
    </TabMenu>
  </div>);
}
